import React from 'react';
import { Building2 } from 'lucide-react';
import CompanyProfileTab from '../tabs/companyProfileTab';

const CompanyProfile: React.FC = () => {
  return (
    <div className="w-full h-full p-6 space-y-6">
      <div className="overflow-hidden border rounded-xl bg-card border-border">
        <div className="px-6 py-5 border-b border-border">
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center w-11 h-11 rounded-xl bg-indigo-100 dark:bg-indigo-900/30 flex-shrink-0">
              <Building2 className="w-5 h-5 text-indigo-600 dark:text-indigo-400" />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-foreground">Perfil de Empresa</h1>
              <p className="mt-0.5 text-sm text-muted-foreground">
                Espacio dedicado para gestionar la identidad y datos de tu empresa.
              </p>
            </div>
          </div>
        </div>

        <div className="max-h-[calc(100vh-250px)] overflow-y-auto scrollbar-custom">
          <CompanyProfileTab />
        </div>
      </div>
    </div>
  );
};

export default CompanyProfile;
